import { PARAMETER_VALUE_TYPE } from '@/constants/ParameterValueTypes.js';
import { normalizeSubsetValue, serializeParameterSubsets } from '@/helpers/parameter/parameterSubsets.js';

const hasValue = value => value !== undefined && value !== null && String(value).trim() !== '';

export const validateSystemName = (value, translate) => {
    if (!hasValue(value)) {
        return undefined;
    }

    const systemName = String(value);

    if (/\s/.test(systemName)) {
        return translate('resources.parameter.validation.noWhitespace');
    }
    if (!/^[A-Za-z0-9_-]+$/.test(systemName)) {
        return translate('resources.parameter.validation.invalidSystemNameChars');
    }
    if (/[-_]{2}/.test(systemName)) {
        return translate('resources.parameter.validation.noConsecutiveSeparators');
    }
    if (/[-_]$/.test(systemName)) {
        return translate('resources.parameter.validation.noTrailingSeparator');
    }

    return undefined;
};

export const validateParameterValue = (value, allValues, translate) => {
    if (!hasValue(value)) {
        return undefined;
    }

    const type = allValues?.type;
    const stringValue = String(value).trim();

    if (type === PARAMETER_VALUE_TYPE.INTEGER && !/^-?\d+$/.test(stringValue)) {
        return translate('resources.parameter.validation.integerValue');
    }

    if (type === PARAMETER_VALUE_TYPE.FLOAT) {
        const normalized = stringValue.replace(',', '.');
        if (!/^-?\d+(\.\d+)?$/.test(normalized) || !Number.isFinite(Number(normalized))) {
            return translate('resources.parameter.validation.numberValue');
        }
    }

    if (type === PARAMETER_VALUE_TYPE.STRING) {
        if (stringValue.length < 3) {
            return translate('common.validation.minLength', { count: 3 });
        }
        if (stringValue.length > 5000) {
            return translate('common.validation.maxLength', { count: 5000 });
        }
    }

    return undefined;
};

export const transformParameterPayload = ({ name, systemName, description, type, value, isSignificant, isActive, subsets }) => {
    return {
        name,
        systemName,
        description,
        type,
        value: normalizeSubsetValue(value, type) ?? '',
        isSignificant: Boolean(isSignificant),
        isActive: isActive !== false,
        subsets: serializeParameterSubsets(subsets, type),
    };
};
